module.exports = __webpack_public_path__ + "static/media/Сентябрьская ночь.6e0e01c0.jpg";